export class Asset {
}
//# sourceMappingURL=Asset.js.map